import React, { Component } from "react";
import { Button } from "../components/Button";
import Input from "../components/Input";
import MunicipalitySelect from "../components/MunicipalitySelect";
import { FormattedMessage } from "react-intl";
import "./SearchForm.css";

export class SearchForm extends Component {
  submitForm = event => {
    event.preventDefault();
    this.props.fetch(0);
  };

  render() {
    const {
      isFormValid,
      locale,
      searching,
      personSearchText,
      updatePersonSearchText,
      selectedMunicipalities,
      updateMunicipalities,
      companySearchText,
      updateCompanySearchText,
      businessIdSearchText,
      updateBusinessIdSearchText,
      officeSearchText,
      updateOfficeSearchText,
      resetForm,
    } = this.props;

    return (
      <form className='searchForm' onSubmit={this.submitForm}>
        <div className='searchControls'>
          <div className='searchInputContainer'>
            <label>
              <FormattedMessage tagName='label' id='common.person' />
              <Input
                type='text'
                placeholder='pestControlOperatorSearch.personSearchPlaceholder'
                value={personSearchText}
                onChange={updatePersonSearchText}
              />
            </label>
          </div>
          <div className='searchInputContainer'>
            <label>
              <FormattedMessage tagName='label' id='common.municipalities' />
              <MunicipalitySelect
                selectedMunicipalities={selectedMunicipalities}
                onChange={updateMunicipalities}
                maxSelections={5}
                locale={locale}
              />
            </label>
          </div>
        </div>
        <div className='searchControls'>
          <div className="searchInputContainer">
            <label htmlFor="searchText">
              <FormattedMessage id="common.company" />
            </label>
            <Input
              autoComplete="off"
              id="searchText"
              type="text"
              placeholder="pestControlOperatorSearch.companySearchPlaceholder"
              value={companySearchText}
              onChange={updateCompanySearchText}
            />
          </div>
          <div className="searchInputContainer">
            <label htmlFor="searchText">
              <FormattedMessage id="common.businessId" />
            </label>
            <Input
              autoComplete="off"
              id="searchText"
              type="text"
              placeholder="pestControlOperatorSearch.businessIdSearchPlaceholder"
              value={businessIdSearchText}
              onChange={updateBusinessIdSearchText}
            />
          </div>
        </div>
        <div className='searchControls'>
          <div className="searchInputContainer">
            <label htmlFor="searchText">
              <FormattedMessage id="common.office" />
            </label>
            <Input
              autoComplete="off"
              id="searchText"
              type="text"
              placeholder="pestControlOperatorSearch.officeSearchPlaceholder"
              value={officeSearchText}
              onChange={updateOfficeSearchText}
            />
          </div>
          <div className='searchInputContainer bottom right'>
            <div className='validatorMessage' role='alert'>
              {!isFormValid() && <FormattedMessage id='pestControlOperatorSearch.inputError' />}
            </div>
            <Button className='clearLink' onClick={resetForm}>
              <FormattedMessage id='common.clearForm' />
            </Button>
            <Button
              className='searchButton'
              type='submit'
              primary
              search
              disabled={searching || !isFormValid()}
            >
              <FormattedMessage id='common.search' />
            </Button>
          </div>
        </div>
        <div className='searchButtonContainer'>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PestControlOperatorSearch/SearchForm.js